<template>
    <div class="text-frame">
        <div v-for="(paragraph, index) in paragraphs" :key="paragraph.type + '-' + index">
            <h1 v-if="paragraph.type == 'heading1'">{{ paragraph.text }}</h1>
            <h2 v-if="paragraph.type == 'heading2'">{{ paragraph.text }}</h2>
            <h3 v-if="paragraph.type == 'heading3'">{{ paragraph.text }}</h3>
            <h4 v-if="paragraph.type == 'heading4'">{{ paragraph.text }}</h4>
            <h5 v-if="paragraph.type == 'heading5'">{{ paragraph.text }}</h5>
            <p  v-if="paragraph.type == 'paragraph'" v-html="serializeParagraph(paragraph)"></p>
            <li v-if="paragraph.type == 'list-item'" v-html="serializeParagraph(paragraph)"></li>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['paragraphs'],
        watch: {
            paragraphs: {
                handler: function() {},
                immediate: true
            }
        },
        methods: {
            serializeParagraph(paragraph) {
                let text = paragraph.text;
                
                if(paragraph.spans.length > 0) {
                    paragraph.spans.slice().reverse().forEach(span => {
                        let link = span.data.url
                        text = this.insertAt(text, "</a>", span.end)
                        text = this.insertAt(text, "<a href=" + link + " target='_blank'>", span.start)
                    });
                }

                return text;
            },
            insertAt (str, sub, pos) {
                return `${str.slice(0, pos)}${sub}${str.slice(pos)}`
            },
            replaceBetween (start, end, what) {
                return this.substring(0, start) + what + this.substring(end);
            }
        }
    }
</script>

<style lang="scss">
    .text-frame {
        padding: 0 1.25rem 0 0;
    }
</style>